import ProgramCard from '@/components/cards/ProgramCard';
import Container, { Column } from '@/components/container/Container';
import { TextHeadlineLarge } from '@/components/text/Texts';
import { X4bUserRoleEnum } from '@/constants/roles';
import { useAuthenticationStore } from '@/store';
import { useState } from 'react';

const YourProgramsSection = () => {
	const blueCar = '/images/svg/blue-car.svg';
	const [selectedPrograms, setSelectedPrograms] = useState<string[]>(['travel']);
	const isManager = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager]);

	const programs = [
		{
			id: 'travel',
			icon: blueCar,
			title: 'Travel Program',
			description: 'Simplify the process for employees to expense rides directly through the Xpress app. Additionally, gain valuable insights into your team\'s transportation expenditure.',
		},
		{
			id: 'business',
			icon: blueCar,
			title: 'Business Travel',
			description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
		},
	];

	return (
		<Container>
			<Column gap="gap-6">
				<TextHeadlineLarge
					text="Your Programs"
					className="text-neutral17"
				/>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					{programs.map((item) => (
						<ProgramCard
							key={item.title}
							imageUrl={item.icon}
							title={item.title}
							description={item.description}
							checked={selectedPrograms.includes(item.id)}

							setChecked={() => {
								if (!isManager) return;
								setSelectedPrograms((prev) =>
									prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id],
								)
							}
							}
						/>
					))}
				</div>
			</Column>
		</Container>
	);
};

export default YourProgramsSection;
